import training from './training.vue'

export default training
